export type WalletCompatibility = "apple-safari" | "apple-other" | "google" | "unknown";

function getUserAgent(): string {
	if (typeof navigator !== 'undefined' && navigator.userAgent) return navigator.userAgent;
	return '';
}

export function getWalletCompatibility(uaInput?: string): WalletCompatibility {
	const ua = (uaInput ?? getUserAgent()) || '';
	const isIOS = /iPhone|iPad|iPod/i.test(ua);
	const isMac = /Macintosh/i.test(ua);
	const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
	const isAndroid = /Android/i.test(ua);
	const isChrome = /Chrome|CriOS|CrMo/i.test(ua) && !/Edg|OPR|SamsungBrowser/i.test(ua);

	if ((isIOS || isMac) && isSafari) return "apple-safari";
	if ((isIOS || isMac) && !isSafari) return "apple-other";
	if (isAndroid || isChrome) return "google"; // desktop Chrome supports Google Save
	return "unknown";
}

export const WalletDetection = {
	getWalletCompatibility,
};


